module.exports = "<logout></logout>";


//////////////////
// WEBPACK FOOTER
// ./src/component/logout/logoutIndex.html
// module id = 177
// module chunks = 0